let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("lJDa4")).then(() => parcelRequire('brzOC'));